<div class="action-form">
  @if (dataContext) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (linkedPropertyDocument) {
        <div>
          <span class="title">{{ 'COMMON.CHANGE_DISPLAYED_FOR' | translate }}</span>
          <div class="form-group">
            <div>{{ 'COMMON.DOCUMENT' | translate }}: {{ linkedPropertyDocument.caption }}</div>
          </div>
          <div class="form-group">
            <app-select [control]="form.controls['visibility']" [itemsSource]="visibilityLevels"></app-select>
          </div>
        </div>
      }
      <div>
        <button class="btn btn-active" type="submit" [disabled]="form.disabled">OK</button>
        <button class="link-btn" (click)="cancel()" [disabled]="form.disabled">{{ 'CANCEL_BTN' | translate }}</button>
      </div>
    </form>
  }
</div>
